import React from "react";
import { FaYoutube } from "react-icons/fa";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">

        {/*/!* Navigation Links *!/*/}
        {/*<div className="footer-section">*/}
        {/*  <h3>Quick Links</h3>*/}
        {/*  <nav>*/}
        {/*    <Link to="/">Home</Link>*/}
        {/*    <Link to="/about">About</Link>*/}
        {/*    <Link to="/blog">Blog</Link>*/}
        {/*    <Link to="/contact">Contact</Link>*/}
        {/*  </nav>*/}
        {/*</div>*/}

        {/* Social Media Icons */}
        <div className="footer-section">
          <h3>Follow Us</h3>
          <div className="social-icons">
            <a href="https://www.youtube.com/channel/UCosPKfKzpl_wMb0B5tY6isA" target="_blank" rel="noopener noreferrer">
              <FaYoutube />
            </a>
            {/*<a href="mailto:AdventureWithLucy@tikitribe.net">*/}
            {/*  <FaEnvelope />*/}
            {/*</a>*/}
          </div>
        </div>

        {/*/!* Subscription Form *!/*/}
        {/*<div className="footer-section">*/}
        {/*  <h3>Join the Adventure</h3>*/}
        {/*  <form className="subscribe-form">*/}
        {/*    <input type="text" placeholder="Name" required />*/}
        {/*    <input type="email" placeholder="Email" required />*/}
        {/*    <button type="submit">Subscribe</button>*/}
        {/*  </form>*/}
        {/*</div>*/}
      </div>

      <style>{`
        .footer {
          background: #f4f4f4;
          padding: 40px 20px;
          text-align: center;
          border-top: 1px solid #ddd;
        }
        .footer-container {
          display: flex;
          flex-wrap: wrap;
          justify-content: center;
          gap: 30px;
        }
        .footer-section {
          flex: 1;
          min-width: 250px;
        }
        .footer-section h3 {
          margin-bottom: 15px;
        }
        .social-icons a {
          margin: 0 10px;
          font-size: 24px;
          color: #333;
        }
        .subscribe-form input {
          display: block;
          width: 100%;
          margin-bottom: 10px;
          padding: 8px;
          border: 1px solid #ccc;
        }
        .subscribe-form button {
          background: #007bff;
          color: white;
          padding: 10px;
          border: none;
          cursor: pointer;
        }
        .footer-disclaimer {
          margin-top: 20px;
          font-size: 14px;
          color: #666;
        }
      `}</style>
    </footer>
  );
};

export default Footer;